import React from 'react';
import './Spinner.css';

export interface SpinnerProps {
  /** Size of the spinner */
  size?: 'small' | 'medium' | 'large';
  /** Color/animation variant */
  variant?: 'primary' | 'secondary' | 'white' | 'warm' | 'rainbow' | 'books';
  /** Additional CSS class */
  className?: string;
  /** Accessible label */
  label?: string;
}

/**
 * Loading spinner component.
 * Animated shuffling cards for async operations.
 */
export const Spinner: React.FC<SpinnerProps> = ({
  size = 'medium',
  variant = 'primary',
  className = '',
  label = 'Loading',
}) => {
  return (
    <div
      className={`stc-spinner stc-spinner--${size} stc-spinner--${variant} ${className}`}
      role="status"
      aria-label={label}
    >
      <div className="stc-spinner__cards">
        <div className="stc-spinner__card" />
        <div className="stc-spinner__card" />
        <div className="stc-spinner__card" />
      </div>
      <span className="stc-visually-hidden">{label}</span>
    </div>
  );
};
